import { Component, Input } from '@angular/core';
import {
  IOdbCoverDetailDivisionSummaryCategories,
  OdbCoverDetailDivision,
} from '@dch/billing-business-logic';

@Component({
  selector: '[my-bill-odb-product-split-identifier]',
  templateUrl: './odb-product-split-identifier.component.html',
  standalone: false,
})
export class OdbProductSplitIdentifierComponent {
  @Input() identifier: string;
  @Input() category: keyof IOdbCoverDetailDivisionSummaryCategories;
  @Input() divisionType: OdbCoverDetailDivision['type'];

  get iconClass(): string {
    if (this.divisionType === 'mobile') {
      return 'icon-Smartphone';
    } else if (
      ['usage', 'oneTimeCharge'].includes(this.category) &&
      this.divisionType === 'address'
    ) {
      return 'icon-Telephony';
    }
  }
}
